import { SharedModule } from "./../../app/shared.module";
import { LoginProvider } from "../../providers/login/login";
import { NgModule } from "@angular/core";

import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { NewposComponent } from "./newpos.component";

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
	direction: 'horizontal',
	slidesPerView: 'auto'
};


@NgModule({
	declarations: [NewposComponent],
	imports: [
		SwiperModule,
		SharedModule
	],
	exports: [NewposComponent],
	providers: [
		LoginProvider,
		{
			provide: SWIPER_CONFIG,
			useValue: DEFAULT_SWIPER_CONFIG
		}
	]
})
export class NewposModule { }
